import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import GridWrapper from './GridWrapper'
import GameIcon from '@material-ui/icons/Star'

const styles = theme => ({
  flex: {
    flex: 1,
    textDecoration: 'none',
    fontWeight: 300,
  },
  menuButton: {
    marginLeft: -12,
  },
  button: {
    marginLeft: 10,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
  },
  list: {
    paddingTop: 0,
  },
  iFrame: {
    backgroundColor: 'rgb(78,85,93)',
  },
  framed: {
    width: 341,
    height: 490,
    overflow: 'hidden',
    padding: 0,
    margin: 0,
  },
})
let id = 0;
function createData(name, first, second, third, last) {
  id += 1;
  return { id, name, first, second, third, last };
}
const data = [
  createData('Exciting stuff', 159, 6.0, 24, 4.0),
  createData('Imaginative', 237, 9.0, 37, 4.3),
  createData('Example', 262, 16.0, 24, 6.0),
  createData('Super table', 305, 3.7, 67, 4.3),
  createData('Many Sports', 356, 16.0, 49, 3.9),
  createData('Very Wow', 237, 9.0, 37, 4.3),
  createData('Genial', 262, 16.0, 24, 6.0),
  createData('Much nice', 305, 3.7, 67, 4.3),
  createData('Great', 356, 16.0, 49, 3.9),
];

function DemoContents(props) {
  const { classes, variant, iFrameContents, showLinks, image } = props
  return (
    <GridWrapper variant={variant}>
      <Grid item xs={iFrameContents || showLinks || image ? 8 : 12}>
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Name (100g serving)</TableCell>
                <TableCell numeric>First</TableCell>
                <TableCell numeric>Second</TableCell>
                <TableCell numeric>Third</TableCell>
                <TableCell numeric>Last</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map(n => {
                return (
                  <TableRow key={n.id}>
                    <TableCell>{n.name}</TableCell>
                    <TableCell numeric>{n.first}</TableCell>
                    <TableCell numeric>{n.second}</TableCell>
                    <TableCell numeric>{n.third}</TableCell>
                    <TableCell numeric>{n.last}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>
      </Grid>
      <Grid item xs={4}>
        {image &&
        <Paper className={classes.framed}>
          {image}
        </Paper>
        }
        {iFrameContents &&
        <Paper className={classes.framed}>
          <iframe
            src={iFrameContents}
            className={classes.iFrame}
            frameBorder="0"
            scrolling="no"
            width="341"
            height="490"
            title="game"
          />
        </Paper>
        }
        {showLinks &&
          <Paper>
            <List component="nav" className={classes.list}>
              <ListItem button onClick={() => window.amigoGames.openBlackjack()}>
                <ListItemIcon><GameIcon /></ListItemIcon>
                <ListItemText inset primary="Blackjack" />
              </ListItem>
              <ListItem button onClick={() => window.amigoGames.openPoker3()}>
                <ListItemIcon><GameIcon /></ListItemIcon>
                <ListItemText inset primary="Poker Three" />
              </ListItem>
              <ListItem button onClick={() => window.amigoGames.openCasinoWar()}>
                <ListItemIcon><GameIcon /></ListItemIcon>
                <ListItemText inset primary="Mini Casino War" />
              </ListItem>
              <ListItem button onClick={() => window.amigoGames.openSlotCritters()}>
                <ListItemIcon><GameIcon /></ListItemIcon>
                <ListItemText inset primary="Slot Critters" />
              </ListItem>
              <ListItem button onClick={() => window.amigoGames.openSlotFrodi()}>
                <ListItemIcon><GameIcon /></ListItemIcon>
                <ListItemText inset primary="Slot Frodi" />
              </ListItem>
              <ListItem button onClick={() => window.amigoGames.openSlotJungle()}>
                <ListItemIcon><GameIcon /></ListItemIcon>
                <ListItemText inset primary="Slot Jungle" />
              </ListItem>
              <ListItem button onClick={() => window.amigoGames.openVPJacksOrBetter()}>
                <ListItemIcon><GameIcon /></ListItemIcon>
                <ListItemText inset primary="VP Jacks or Better" />
              </ListItem>
              <ListItem button onClick={() => window.amigoGames.openCaribbeanStud()}>
                <ListItemIcon><GameIcon /></ListItemIcon>
                <ListItemText inset primary="Caribbean Stud" />
              </ListItem>
              <ListItem button onClick={() => window.amigoGames.openKeepEmPoker()}>
                <ListItemIcon><GameIcon /></ListItemIcon>
                <ListItemText inset primary="Keep Em Poker" />
              </ListItem>
              <ListItem button onClick={() => window.amigoGames.openRedDog()}>
                <ListItemIcon><GameIcon /></ListItemIcon>
                <ListItemText inset primary="Red Dog" />
              </ListItem>
            </List>
          </Paper>
        }
      </Grid>
    </GridWrapper>
  )
}

DemoContents.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(DemoContents)


// WEBPACK FOOTER //
// ./src/components/DemoContents.js